<template>
  <SysDialog
    v-model="DIALOG_ATIVO"
    :titulo="`Relatório ${relatorio.title}`"
    txt-botao="Gerar relatório"
    @click:primary="gerarRelatorio"
  >
    <v-checkbox v-model="filtros.fora_de_linha" hide-details class="pb-3">
      <template #label>
        <span class="ml-1 font-15">Produtos fora de linha</span>
      </template>
    </v-checkbox>

    <div class="d-flex align-center">
      <div class="w-50-porcento pr-2">
        <SysGrupoAutocomplete
          v-model="filtros.grupos"
          label="Grupos"
          outlined
          multiple
          hide-details
        />
      </div>

      <div class="w-50-porcento pl-2">
        <SysFilialGrupoAutocomplete
          v-model="filtros.filiais"
          label="filiais"
          outlined
          hide-details
          multiple
        />
      </div>
    </div>

    <SysCompradorAutocomplete
      v-model="filtros.compradores"
      label="Compradores"
      outlined
      multiple
      hide-details
      class="mt-4"
    />

    <SysSegmentoAutocomplete
      v-model="filtros.segmentos"
      label="Segmentos"
      outlined
      multiple
      hide-details
      class="mt-4"
    />
    
    <SysFornecedorAutocomplete
      v-model="filtros.fornecedores"
      label="Fornecedores"
      outlined
      multiple
      :ids-segmento="filtros.segmentos"
      hide-details
      class="mt-4"
    />
  </SysDialog>
</template>

<script>
import Mixin from "@/components/Relatorios/Mixin";
import SysGrupoAutocomplete from "@/components/utils/crud/SysGrupoAutocomplete";
import SysFilialGrupoAutocomplete from "@/components/utils/crud/SysFilialGrupoAutocomplete";
import SysSegmentoAutocomplete from "@/components/utils/crud/SysSegmentoAutocomplete";
import SysFornecedorAutocomplete from "@/components/utils/crud/SysFornecedorAutocomplete";
import SysCompradorAutocomplete from "@/components/utils/crud/SysCompradorAutocomplete";
import $axios from "@/api/api";

export default {
  name: "EstoqueAnaliseGerencial",
  mixins: [Mixin],
  components: {
    SysFornecedorAutocomplete,
    SysSegmentoAutocomplete,
    SysFilialGrupoAutocomplete,
    SysGrupoAutocomplete,
    SysCompradorAutocomplete
  },
  data: () => ({
    filtros: {
      fora_de_linha: true,
      grupos: [],
      filiais: [],
      compradores: [],
      segmentos: [],
      fornecedores: [],
    }
  }),
  methods: {
    gerarRelatorio() {
      const parametros = {
        ...this.filtros,
        fora_de_linha: this.filtros.fora_de_linha ? 'S' : 'N'
      };

      const url = `${$axios.defaults.baseURL}/${this.relatorio.url}`;

      const form = document.createElement('form');
      form.method = 'POST';
      form.action = url;
      form.target = '_blank';

      for (const key in parametros) {
        if (parametros.hasOwnProperty(key)) {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = key;
          input.value = parametros[key];
          form.appendChild(input);
        }
      }

      document.body.appendChild(form);
      form.submit();

      document.body.removeChild(form);

      this.DIALOG_ATIVO = false;
    }
  }
}
</script>

<style scoped>

</style>
